import {connect} from 'react-redux';
import RegHome from './RegHome.jsx';
import {handlePartnerLoginClick, handleExitPartnerClick} from '../../shared/topBanner/actions';

const mapStateToProps = state => ({
  activeTournamentCount: state.registration.home.activeTournamentCount,
  activeTournamentsQty: state.registration.home.activeTournaments.length,
  loadingTournaments: state.registration.home.loadingTournaments,
  paymentMessage: state.registration.home.paymentMessage,
  groupName: state.shared.auth.groupName,
  isAllowed: state.shared.auth.isAllowed,
  roles: state.shared.auth.roles,
  permissions: state.shared.auth.permissions
});

const mapDispatchToProps = (dispatch) => ({
  onPartnerLoginClick: () => dispatch(handlePartnerLoginClick()),
  onExitPartnerClick: () => dispatch(handleExitPartnerClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(RegHome);



// WEBPACK FOOTER //
// ./src/features/registration/home/RegHomeContainer.jsx